if (!customElements.get('dfw-location-stock')) {
  customElements.define('dfw-location-stock', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.product = JSON.parse(this.querySelector('[data-stock-product]').textContent);
      this.labels = this.querySelector('[data-stock-labels]').dataset;
      this.widgetObserver = new MutationObserver(() => this.updateWidgetWording());
      this.widgetObserver.observe(this.querySelector('.dfw-stock-widget'), { childList: true, subtree: true, characterData: true });
      this.updateWidgetWording();
      this.rows = this.querySelector('.dfw-stock-rows');
      this.variantId = String(this.product.variant_id || '');
      this.events = new AbortController();
      this.selectSequence = 0;
      document.addEventListener('shopify:product:select', async event => {
        const data = event;
        if (String(data?.product?.id || '').split('/').pop() !== String(this.product.product_id)) return;
        const sequence = ++this.selectSequence;
        this.request?.abort();
        this.request = null;
        this.pending = true;
        this.setStatus(this.labels.loading);
        try {
          const result = await data.promise;
          if (!this.isConnected || sequence !== this.selectSequence) return;
          const id = result?.detail?.resource?.id || result?.variant?.id;
          this.variantId = id ? String(id).split('/').pop() : '';
          this.refresh();
        } catch (error) {
          if (sequence === this.selectSequence) {
            this.pending = false;
            this.setStatus(this.labels.error);
          }
        }
      }, { signal: this.events.signal });
      window.addEventListener('focus', () => this.refreshIfStale(), { signal: this.events.signal });
      window.addEventListener('pageshow', () => this.refreshIfStale(), { signal: this.events.signal });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.refreshIfStale();
      }, { signal: this.events.signal });
      this.timer = setInterval(() => {
        if (!document.hidden) this.refreshIfStale();
      }, 60000);
      this.refresh();
    }
    disconnectedCallback() {
      this.widgetObserver?.disconnect();
      this.events?.abort();
      this.request?.abort();
      clearInterval(this.timer);
      this.started = false;
    }
    updateWidgetWording() {
      const heading = this.querySelector('#zapiet-delivery-info__title');
      if (heading && heading.textContent !== this.labels.widgetHeading) heading.textContent = this.labels.widgetHeading;
      const title = this.querySelector('#zapiet-delivery-info__delivery_title');
      if (title && /^Delivery\b/.test(title.textContent)) title.textContent = title.textContent.replace(/^Delivery\b/, this.labels.localDelivery);
    }
    refreshIfStale() {
      if (!this.pending && Date.now() - (this.updatedAt || 0) > 15000) this.refresh();
    }
    setStatus(text) {
      this.querySelectorAll('[data-stock-city]').forEach(row => { row.textContent = text; });
      this.rows.setAttribute('aria-busy', String(text === this.labels.loading));
    }
    async refresh() {
      this.request?.abort();
      const controller = new AbortController();
      this.request = controller;
      if (!this.variantId) { this.pending = false; this.setStatus(this.labels.unavailable); return; }
      this.pending = true;
      const locations = [];
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        for (let page = 1; page <= 10; page++) {
          const response = await fetch(`https://api.zapiet.com/v1.0/product-widget/locations?shop=${encodeURIComponent(this.dataset.shop)}`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ product: { ...this.product, variant_id: Number(this.variantId) }, query: '', page }),
            signal: controller.signal, credentials: 'omit', cache: 'no-store'
          });
          if (!response.ok) throw new Error('Stock lookup failed');
          const result = await response.json();
          if (!Array.isArray(result.locations)) throw new Error('Invalid stock response');
          locations.push(...result.locations);
          if (!result.more) break;
          if (page === 10) throw new Error('Incomplete stock response');
        }
        if (!this.isConnected || this.request !== controller) return;
        this.querySelectorAll('[data-stock-city]').forEach(row => {
          const location = locations.find(location => String(location.city || '').trim().toLowerCase() === row.dataset.stockCity);
          const quantity = location?.stock?.quantity;
          row.textContent = Number.isInteger(quantity) && quantity >= 0 ? String(quantity) :
            quantity === -1 && location?.available ? this.labels.inStock : this.labels.unavailable;
        });
        this.rows.setAttribute('aria-busy', 'false');
        this.updatedAt = Date.now();
      } catch (error) {
        if (this.request === controller && this.isConnected) this.setStatus(this.labels.error);
      } finally {
        clearTimeout(timeout);
        if (this.request === controller) this.pending = false;
      }
    }
  });
}
